import baseApi from '@/app/store/api/baseApi';
import { store } from '@/app/store/store';
import { executeServiceRequest, serviceUrl } from '@/services/core/executeServiceRequest';
import * as apiUrls from '@/utils/core/apiUrls';

import type { ServiceSnackbar as ShowSnackbar } from '@/services/core/executeServiceRequest';
import type {
    MarkNotificationReadResponse,
    NotificationInboxResponse,
} from '@/services/notification/inbox/types';

const baseUrl = apiUrls.API_BASE_URLS.notification;

interface NotificationInboxRequest {
    localAt: string;
}

export const notificationServiceApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNotificationInbox: builder.query<NotificationInboxResponse, NotificationInboxRequest>({
            query: (params) => ({
                url: serviceUrl(apiUrls.API_PATHS.notification.inbox, baseUrl),
                method: 'GET',
                params,
            }),
        }),
        markNotificationAsRead: builder.mutation<MarkNotificationReadResponse, string>({
            query: (usrNtfctnInboxId) => ({
                url: serviceUrl(apiUrls.API_PATHS.notification.markRead(usrNtfctnInboxId), baseUrl),
                method: 'PUT',
                body: {},
            }),
        }),
    }),
});

/** Local datetime as YYYY-MM-DDTHH:mm:ss (no timezone), matching API samples. */
const getNotificationLocalAt = (date = new Date()): string => {
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const getNotificationInbox = async (
    showSnackbar?: ShowSnackbar,
    localAt: string = getNotificationLocalAt(),
): Promise<NotificationInboxResponse> => {
    return executeServiceRequest<NotificationInboxResponse>(
        store.dispatch(
            notificationServiceApi.endpoints.getNotificationInbox.initiate(
                { localAt },
                { subscribe: false, forceRefetch: true },
            ),
        ),
        showSnackbar,
        apiUrls.API_PATHS.notification.inbox,
    );
};

export const markNotificationAsRead = async (
    usrNtfctnInboxId: string,
    showSnackbar?: ShowSnackbar,
): Promise<MarkNotificationReadResponse> => {
    return executeServiceRequest<MarkNotificationReadResponse>(
        store.dispatch(
            notificationServiceApi.endpoints.markNotificationAsRead.initiate(usrNtfctnInboxId, {
                track: false,
            }),
        ),
        showSnackbar,
        apiUrls.API_PATHS.notification.markRead(usrNtfctnInboxId),
    );
};
